module.exports = __webpack_public_path__ + "img/left-icon.6f2b01f5.png";